module.exports = __webpack_public_path__ + "img/book.7f72a543.png";